import { RootReducerType } from "../CombineReducer";

export const useGetAuthInfo = (state: RootReducerType) => state.xeroInfo?.authInfo;
